import {
    Module, VuexModule, Mutation, Action, getModule,
} from 'vuex-module-decorators';
import store from '@/state/store';
import { updateInfoAPI } from '@samclick-static-urls';
import { sendGet, sendPut } from '@samclick-api-client';
import { sendUAGet, sendUAPut } from '@/api-client/unified-api';
import { affiliateAPI as affiliateUAAPI } from '@/api-client/static-url-ua';
import Payload from './payload';


class UpdateinfoState {
    public loading: boolean = false

    public currentPaymentAccount: object = {}

    public currentPostbackSetting: object = {}

    public affiliateBetaFeatures: object[] = []

    public isPostbackFeatureEnabled: boolean = false
}

@Module({
    namespaced: true,
    dynamic: true,
    store,
    name: 'updateinfo',
})
class UpdateinfoStore extends VuexModule {
    updateinfoStore: UpdateinfoState = new UpdateinfoState();

    @Mutation
    UPDATEINFO_REINITIALIZE() {
        this.updateinfoStore = new UpdateinfoState();
    }

    @Mutation
    SET_UPDATEINFO_LOADING(loading: boolean) {
        this.updateinfoStore.loading = loading;
    }

  @Mutation
    SET_UPDATEINFO_CURRENT_ACCOUNT(response: object) {
        this.updateinfoStore.currentPaymentAccount = response || {};
    }

  @Mutation
  SET_UPDATEINFO_CURRENT_POSTBACK_SETTING(response: object) {
      this.updateinfoStore.currentPostbackSetting = response || {};
  }

  @Mutation
  SET_UPDATEINFO_BETA_FEATURES(response: object[]) {
      this.updateinfoStore.affiliateBetaFeatures = response || [];
  }

  @Mutation
  SET_UPDATEINFO_POSTBACK_FEATURE_ENABLED(enabled: boolean) {
      this.updateinfoStore.isPostbackFeatureEnabled = !!enabled;
  }

    @Action({ rawError: true })
  showLoader(show: boolean) {
      this.context.commit('SET_UPDATEINFO_LOADING', show);
  }

    @Action({ rawError: true })
    destroyUpdateinfo() {
        this.context.commit('UPDATEINFO_REINITIALIZE');
    }

  @Action({ rawError: true })
    updateInfo(payload: Payload) {
        this.showLoader(payload.activateLoader);
        return new Promise((resolve, reject) => {
            sendPut(updateInfoAPI.updateInfo, payload.data).then((response) => {
                this.showLoader(false);
                resolve(response);
            }, (error) => {
                this.showLoader(false);
                reject(error.response);
            });
        });
    }

  @Action({ rawError: true })
  updatePaymentThreshold(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPut(updateInfoAPI.updatePaymentThreshold, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getCurrentPaymentAccount(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendGet(updateInfoAPI.getCurrentPaymentGET, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_UPDATEINFO_CURRENT_ACCOUNT', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  updatePaymentAccount(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendPut(updateInfoAPI.createUpdatePaymentAccountPUT, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getPostbackSettings(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getPostbackSettings, payload.data).then((response) => {
              if (payload.storeData) {
                  this.context.commit('SET_UPDATEINFO_CURRENT_POSTBACK_SETTING', response.data);
              }
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  updatePostbackSettings(payload: Payload) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendUAPut(affiliateUAAPI.updatePostbackSettings, payload.data).then((response) => {
              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }

  @Action({ rawError: true })
  getAffiliateBetaFeatures(payload: Payload = new Payload()) {
      this.showLoader(payload.activateLoader);
      return new Promise((resolve, reject) => {
          sendUAGet(affiliateUAAPI.getAffiliateBetaFeatures, payload.data).then((response) => {
              const betaFeatures = response.data || [];
              const postbackEnabled = Array.isArray(betaFeatures) && betaFeatures.some((feature: any) => {
                  const featureName = (feature && feature.feature_name) || '';
                  return String(featureName).toLowerCase() === 'postback' && Number(feature.status) === 1;
              });

              if (payload.storeData !== false) {
                  this.context.commit('SET_UPDATEINFO_BETA_FEATURES', betaFeatures);
                  this.context.commit('SET_UPDATEINFO_POSTBACK_FEATURE_ENABLED', postbackEnabled);
              }

              this.showLoader(false);
              resolve(response);
          }, (error) => {
              this.showLoader(false);
              reject(error.response);
          });
      });
  }
}


export default getModule(UpdateinfoStore);
